class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    const filterCount = container.dataset.count;
    // document.querySelector('.btn-filter-count').innerHTML = `(${count})`;
    FacetFiltersForm.updateMobileFilterCounts();
  }

  // Update mobile filter count and apply button count dynamically
  static updateMobileFilterCounts() {
    const mobileCount = document.querySelector('.mobile-facets__count');
    if (!mobileCount) return 1;

    const text = mobileCount.innerText.trim(); // "9 of 21 products"
    const match = text.match(/(\d+)\s+of/);
    const applyBtn = document.querySelector('.btn-filter-count');
    if (applyBtn) {
      applyBtn.innerHTML = match ? `(${match[1]})` : `(1)`;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
  
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    // Bind methods
    this.onRangeChange = this.onRangeChange.bind(this);
    this.onRangeSliderInput = this.onRangeSliderInput.bind(this);

    // Initialize text inputs
    this.querySelectorAll('input[name^="filter.v.price"]').forEach((element) => {
      element.addEventListener('change', this.onRangeChange);
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    
    this.setMinAndMaxValues();

    // Initialize range sliders if they exist
    this.initializeRangeSliders();
   
    
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();

    // Update range sliders if they exist
    this.syncRangeSlidersWithInputs();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  initializeRangeSliders() {
    // Look for slider inputs (without name attribute to avoid duplicate URL params)
    this.minRangeSlider = this.querySelector('.price-slider__input--min');
    this.maxRangeSlider = this.querySelector('.price-slider__input--max');
    this.progressBar = this.querySelector('.price-slider__progress');
        
    if (!this.minRangeSlider || !this.maxRangeSlider || !this.progressBar) return;
    
    // Get current values from number inputs (these have name attributes and submit to form)
    const numberInputs = this.querySelectorAll('input[name^="filter.v.price"]');
    const minInput = numberInputs[0];
    const maxInput = numberInputs[1];
    
    // Set initial slider values from number inputs
    if (minInput && minInput.value) {
      this.minRangeSlider.value = minInput.value;
    }
    if (maxInput && maxInput.value) {
      this.maxRangeSlider.value = maxInput.value;
    }
    
    // Update progress bar initially
    this.updateSliderProgress();
    
    // Add event listeners
    this.minRangeSlider.addEventListener('input', this.onRangeSliderInput);
    this.maxRangeSlider.addEventListener('input', this.onRangeSliderInput);
  }

  onRangeSliderInput(event) {
    const minValue = parseInt(this.minRangeSlider.value);
    const maxValue = parseInt(this.maxRangeSlider.value);
   
    // Prevent sliders from crossing
    if (event.target === this.minRangeSlider && minValue > maxValue) {
      this.minRangeSlider.value = maxValue;
    }
    if (event.target === this.maxRangeSlider && maxValue < minValue) {
      this.maxRangeSlider.value = minValue;
    }
    
    // Update progress bar
    this.updateSliderProgress();
    
    // Sync with number inputs (these have name attributes and will submit)
    this.syncInputsWithRangeSliders();
  }

  updateSliderProgress() {
    if (!this.progressBar || !this.minRangeSlider || !this.maxRangeSlider) return;
    
    const minValue = parseInt(this.minRangeSlider.value);
    const maxValue = parseInt(this.maxRangeSlider.value);
    const minRange = parseInt(this.minRangeSlider.min);
    const maxRange = parseInt(this.minRangeSlider.max);
    
    const leftPercent = ((minValue - minRange) / (maxRange - minRange)) * 100;
    const rightPercent = ((maxRange - maxValue) / (maxRange - minRange)) * 100;
    
    this.progressBar.style.left = `${leftPercent}%`;
    this.progressBar.style.right = `${rightPercent}%`;
  }

  syncRangeSlidersWithInputs() {
    if (!this.minRangeSlider || !this.maxRangeSlider) return;
    
    const numberInputs = this.querySelectorAll('input[name^="filter.v.price"]');
    const minInput = numberInputs[0];
    const maxInput = numberInputs[1];
    
    if (minInput && minInput.value) {
      this.minRangeSlider.value = minInput.value;
    }
    if (maxInput && maxInput.value) {
      this.maxRangeSlider.value = maxInput.value;
    }
    
    this.updateSliderProgress();
  }

  syncInputsWithRangeSliders() {
    const inputs = this.querySelectorAll('input[name^="filter.v.price"]');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    const formatMoney = (value) => {
      return new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    };

    if (minInput) {
      minInput.value = formatMoney(this.minRangeSlider.value);
      minInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    if (maxInput) {
      maxInput.value = formatMoney(this.maxRangeSlider.value);
      maxInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".load-more");
  if (!btn) return;

  e.preventDefault();

  const url = btn.getAttribute("href");
  if (!url) return;

  btn.innerText = "Loading...";
  btn.style.pointerEvents = "none";

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, "text/html");

      let newItems = doc.querySelectorAll("#ProductGridContainer .product-grid > *");
      let container = document.querySelector("#ProductGridContainer .product-grid");

      if (!container) return;

      newItems.forEach(el => container.appendChild(el));

      const newBtnWrapper = doc.querySelector(".lodeMore-btn-wpr");
      const oldBtnWrapper = document.querySelector(".lodeMore-btn-wpr");

      if (newBtnWrapper) {
        oldBtnWrapper.replaceWith(newBtnWrapper);
      } else if (oldBtnWrapper) {
        oldBtnWrapper.remove();
      }
    })
    .catch(() => {
      btn.innerText = "LOAD MORE";
      btn.style.pointerEvents = "auto";
    });
});

document.addEventListener('DOMContentLoaded', function () {

  /* Onload price accordion open */
  const allAccordions = document.querySelectorAll('[data-accordion]');  
  allAccordions.forEach(function (group) {
    const title = group.querySelector('[data-accordion-title]');
    const content = title ? title.nextElementSibling : null;
    
    if (title && content && group.querySelector('.facets__price, price-range, [id*="Price"]')) {
      title.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
});


document.addEventListener('change', function (e) {
  const input = e.target.closest('.drawer-sort-input');
  if (!input) return;

  const sortSelect = document.getElementById('SortBy-mobile');
  document.querySelectorAll('.drawer-sort-input').forEach(function (other) {
    other.closest('label').classList.remove('active');
  });
  input.closest('label').classList.add('active');

  // Sync with Dawn's sort select
  if (sortSelect) {
    sortSelect.value = input.dataset.sortValue;
    sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

// document.addEventListener('click', function (e) {
//   e.preventDefault();
//   //console.log(e.target.classList);
// });


// const facetDrawer = document.getElementById("FilterDrawer");
// const facetCursor = document.getElementById("FacetFilterCursor");
// const facetWrapper = facetDrawer.querySelector(".mobile-facets__inner");

// facetDrawer.addEventListener("mousemove", function (e) {
//   if (!facetDrawer.classList.contains("menu-opening")) return;

//   facetCursor.style.left = e.clientX + "px";
//   facetCursor.style.top = e.clientY + "px";

//   if (facetWrapper.contains(e.target)) {
//     facetCursor.classList.remove("show");
//   } else {
//     facetCursor.classList.add("show");
//   }
// });

// facetDrawer.addEventListener("mouseleave", function () {
//   facetCursor.classList.remove("show");
// });